import { render, staticRenderFns } from "./CheckDetails.vue?vue&type=template&id=ef0ba510&scoped=true"
import script from "./CheckDetails.vue?vue&type=script&lang=js"
export * from "./CheckDetails.vue?vue&type=script&lang=js"
import style0 from "./CheckDetails.vue?vue&type=style&index=0&id=ef0ba510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0ba510",
  null
  
)

export default component.exports